module.exports = __webpack_public_path__ + "static/our-firm-3-ccf8ca166627b51c93a2e32cfdbd375f.jpg";